// extracted by mini-css-extract-plugin
export default {"EmptyCart":"EmptyCart_EmptyCart__E9jj7","fadein":"EmptyCart_fadein__1vif2","EmptyCart__Text":"EmptyCart_EmptyCart__Text__IwgQ7"};